import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const TIME_MINS_KEY = 'libs.common.time-format.mins';
const TIME_HOURS_KEY = 'libs.common.time-format.hours';

@Pipe({
  name: 'time',
  standalone: true,
})
export class TimePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(seconds: number, showLabel = false): string {
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    const formatted =
      hours > 0
        ? `${hours}:${mins < 10 ? '0' : ''}${mins}:${secs < 10 ? '0' : ''}${secs}`
        : `${mins < 10 ? '0' : ''}${mins}:${secs < 10 ? '0' : ''}${secs}`;

    if (showLabel) {
      const labelKey = hours > 0 ? TIME_HOURS_KEY : TIME_MINS_KEY;

      return `${formatted} ${this.translate.instant(labelKey)}`;
    }

    return formatted;
  }
}
